// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_co-j";
export var fulfillmentFormRail = "_co-i";
export var headerTitleRow = "_co-l";
export var orderDetailsWrapper = "_co-g";
export var orderLinkTrigger = "_co-2";
export var paymentInformationGrid = "_co-q";
export var paymentSummaryColumn = "_co-r";
export var phoneShipmentPickerButton = "_co-e";
export var phoneShipmentPickerButtonContent = "_co-f";
export var phoneShipmentPickerButtonWrapper = "_co-d";
export var phoneShipmentPickerTrigger = "_co-c";
export var shipmentContainer = "_co-k";
export var shipmentDetailsMainPane = "_co-h";
export var shipmentNavigationCard = "_co-a";
export var shipmentNavigationEdgeTrigger = "_co-6";
export var shipmentNavigationRail = "_co-3";
export var shipmentNavigationRailEnter = "_co-5";
export var shipmentNavigationRailHeader = "_co-9";
export var shipmentNavigationRailOverlay = "_co-4";
export var shipmentNavigationScrim = "_co-7";
export var shipmentSummaryFact = "_co-n";
export var shipmentSummaryGrid = "_co-m";
export var shipmentSummaryMetadataRow = "_co-o";
export var shipmentSummaryTags = "_co-p";
export var shipmentWorkspace = "_co-0";
export var shipmentWorkspaceBodyTablet = "_co-8";
export var shipmentWorkspaceContent = "_co-b";
export var shipmentWorkspaceHeader = "_co-1";